import React from "react";
import "./Contact.css";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import { MdOutlineMailOutline } from "react-icons/md";
import { RiMessengerLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import i18n from "../../languages/i18n";
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
  const form = useRef();
  const { t } = useTranslation();
  const [captachaDone, setCaptachaDone] = useState(false);
  const onChange = (value) => {
    console.log("Site key-done :", process.env.site_key);

    setCaptachaDone(true);
  };
  //const [toUser,setToUser] =useState('');
  //emailjs.sendForm(serviceID, templateID, templateParams, publicKey);
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.emailjs_serviceID,
        process.env.emailjs_templateID,
        form.current,
        process.env.emailjs_publicKey
      )
      .then(
        (result) => {
          alert("Thank you for your contact, I received your mail 💗");

          e.target.reset();

          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <section id="contact">
      <h5 className={i18n.language === "ar" && "arabicText title_h5 "}>
        {t("contactSection.get_touch_title")}
      </h5>
      <h2 className={i18n.language === "ar" && "arabicText title_h2 "}>
        {t("contactSection.contact_m_title")}
      </h2>
      <div className="container contact_container">
        <div className="contact_options">
          <article className="contact_option">
            <MdOutlineMailOutline size={23} className="contact_option-icon" />
            <h4>Email</h4>
            <h5>smichi.mahjoub@gmail.com</h5>
            <a
              href="mailto:smichi.mahjoub@gmail.com"
              target="_blank"
              rel="noreferrer"
              className={i18n.language === "ar" && "arabicText title_h2 "}
            >
              {t("contactSection.send_mess_title")}
            </a>
          </article>
          <article className="contact_option">
            <RiMessengerLine size={23} className="contact_option-icon" />
            <h4>Messenger</h4>
            <h5>smichi.jb</h5>
            <a
              href="https://m.me/smichi.jb"
              target="_blank"
              rel="noreferrer"
              className={i18n.language === "ar" && "arabicText title_h2 "}
            >
              {t("contactSection.send_mess_title")}
            </a>
          </article>
          <article className="contact_option">
            <FaWhatsapp size={23} className="contact_option-icon" />
            <h4>Whatsup</h4>
            <h5>0021624066794</h5>
            <a
              href="https://api.whatsup.com/send?phone+21624066794"
              target="_blank"
              rel="noreferrer"
              className={i18n.language === "ar" && "arabicText title_h2 "}
            >
              {t("contactSection.send_mess_title")}
            </a>
            {/*<h4 id="toUser" >{toUser}</h4>*/}
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail} className="contact-form">
          <input
            type="text"
            name="name"
            placeholder={t("testiSection.youName_title")}
            className={i18n.language === "ar" && "arabicText rtlText "}
            required
          />
          <input
            type="email"
            name="email"
            className={i18n.language === "ar" && "arabicText rtlText "}
            placeholder={t("testiSection.youMail_title")}
            required
          />
          <input
            type="text"
            name="company"
            placeholder={t("testiSection.yourCompany_Title")}
            required
            className={i18n.language === "ar" && "arabicText rtlText "}
          />
          <textarea
            name="message"
            rows="8"
            placeholder={t("testiSection.message_title")}
            required
            className={i18n.language === "ar" && "arabicText rtlText "}
          ></textarea>

          <ReCAPTCHA
            sitekey={process.env.recaptcha_siteKey}
            onChange={onChange}
            onExpired={() => setCaptachaDone(false)}
          />

          {captachaDone && (
            <button
              type="submit"
              className={
                i18n.language === "en"
                  ? "btn btn-primary"
                  : "btn btn-primary arabicText"
              }
            >
              {t("btn_send_title")}
            </button>
          )}
        </form>
      </div>
    </section>
  );
};

export default Contact;
